import { FLOW_PERMISSIONS } from 'store/enums'; // APP_ROLES
import store from 'store';

export const userRole = () => store.getters['auth/data']('userInfo')?.role;

export const userProfile = () => store.getters['auth/data']('userInfo');

export const userPartnerId = () => store.getters['auth/data']('userInfo')?.partnerid;

export const userName = async () => {
  const profile = userProfile();
  return profile.name;
};

export const userContactId = async () => {
  const profile = userProfile();
  return profile.contactId;
};

export const userSignedIn = () => store.getters['auth/data']('userInfo') !== null;

export const checkAvailabilityRole = (role, check) => {
  if (Array.isArray(role)) {
    return role.some(item => check.includes(item));
  }
  return check.includes(role);
};

export const checkPermissionsMatch = (userRoles, requiredPermissions) => {
  if (Array.isArray(userRoles)) {
    return userRoles.some(item => requiredPermissions.includes(item));
  }
  return requiredPermissions.includes(userRoles);
};

export const getPermissionFlow = () => {
  const userRoles = userRole();
  const flowPermissionsAccordingToRole = {};
  Object.keys(FLOW_PERMISSIONS).forEach(key => {
    flowPermissionsAccordingToRole[key.toLocaleUpperCase()] = checkPermissionsMatch(
      userRoles,
      FLOW_PERMISSIONS[key]
    );
  });
  return flowPermissionsAccordingToRole;
};
